import { createStrings } from '@utils/local';

export const seaWaybillStrings = createStrings({
  ja: {
    seaWaybill: 'Sea Waybill',
    place_of_receipt: 'Place of Receipt',
    house_bl_number: 'HBL',
    shipper: 'Shipper',
    commodity: 'Commodity',
    prepaid_collect: 'Prepaid/Collect',
    shipping_mark: 'Shipping Mark',
    payments_terms: 'Payment Terms',
    consignee: 'Consignee',
    nos: 'Quantity',
    gross_weight: 'Gross Weight',
    measurement: 'Measurement',
    packages: 'Packages',
    chargeable_weight: 'Chargeable Weight',
    place_of_delivery: 'Place of Delivery',
    vessel: 'Vessel',
    pol: 'POL',
    pod: 'POD',
    etd: 'ETD',
    voyage: 'Voyage',
  },
});

export const seaWaybillPaymentTerms = ['DDU', 'DDP', 'EXW', 'FCA'];
